import { ROLE_IDS, type RoleKeys } from "../../../constants/roles.ts"
import { RoutesPaths } from "../../../constants/routes.ts"
import { type Project } from "../types/project.types.ts"

const PROJECT_OVERVIEW_ROLES: RoleKeys[] = [
  ROLE_IDS.ADMIN_GCC,
  ROLE_IDS.ADMIN_PLATFORM
]

export const getProjectNavigatePath = (
  project: Project,
  userId: string | undefined,
  roleId: RoleKeys | undefined,
  projectsPath: string = RoutesPaths.project.grid
) => {
  if (PROJECT_OVERVIEW_ROLES.includes(roleId as RoleKeys)) {
    return RoutesPaths.project.view(project.id).overview
  }

  const isAssignedToMe = project?.project_managers?.some(
    (p) => p?.id === userId
  )

  return isAssignedToMe
    ? RoutesPaths.project.view(project.id).overview
    : projectsPath
}
